import React from "react";
import { withStyles } from "@material-ui/core/styles";
import { initialValues } from "./values";
import { loginFormValidationSchema } from "./validation";
import Field from "../../../common/components/Field";
import { Formik } from "formik";
import { Grid, Button, Card } from "@material-ui/core";
import styles from "./styles";

const RegisterGroup = ({ classes, data, isLoading, registerGroup }) => {
  return (
    <Formik
      initialValues={initialValues()}
      validationSchema={loginFormValidationSchema}
    >
      {(formik) => (
        <div>
          <Card
            style={{
              margin: "auto",
              padding: 10,
              display: "flex",
              maxWidth: 230,
              background: "#fff",
              flexDirection: "column",
            }}
          >
            <Grid container>
              <Grid item>
                <Field
                  formik
                  label="Nome do grupo"
                  name="nameGroup"
                  formik={formik}
                />
                <Field
                  formik
                  label="Descrição"
                  name="description"
                  formik={formik}
                />
              </Grid>
            </Grid>
            <Button
              onClick={() => registerGroup(formik.values)}
              className={classes.button}
            >
              CADASTRAR
            </Button>
          </Card>
        </div>
      )}
    </Formik>
  );
};

export default withStyles(styles)(RegisterGroup);
